import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AuthProvider } from './contexts/AuthContext';
import { useGstShortcut } from './utils/useGstShortcut';

if (process.env.REACT_APP_ENV === "staging") {
  console.log("Running on staging server");
} else if (process.env.REACT_APP_ENV === "development") {
  console.log("Running on development server");
} else if (process.env.REACT_APP_ENV === "production") {
  console.log("Running on production server");
}

const App: React.FC = () => {
  useGstShortcut();
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <BrowserRouter>
          <AuthProvider>
            <AppRoutes />
            <ToastContainer
              position="top-right"
              autoClose={2000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              pauseOnHover
              draggable
              theme="colored" // also try "light" or "dark"
            />
          </AuthProvider >
        </BrowserRouter>
      </LocalizationProvider>
    </>
  )

};

export default App;
